/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch } from 'react-redux';
import { AddBoxRounded, MoreVert } from '@material-ui/icons';
import { Card, CardContent, Grid, Menu, MenuItem, TextField, Typography } from '@material-ui/core';
import FileIcon from '../../assets/FileIcon';
import TrashCanIcon from '../../assets/TrashCan';
import AddNewJourneyToRulePopup from './AddNewJourneyToRulePopup';
import service from '../../apis/service';
import { showProgress } from '../../redux/actions/DealershipActions';
import { ErrorToast, notifySuccess, searchArray } from '../utils/Utils';
import ZeroState from '../common/ZeroState';
import { apiEndpoints } from '../../constants/apiEndpoints';
import Image from '../common/Image';

const useStyles = makeStyles(() => ({
  primaryText: {
    paddingLeft: '5px',
    margin: '0',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '134%',
  },
  secondaryText: {
    paddingLeft: '5px',
    margin: '0',
    fontSize: '11px',
    fontWeight: 500,
    lineHeight: '134%',
    color: '#667085',
  },
  scrollContent: {
    marginTop: '10px',
    marginLeft: '3px',
    width: '99%',
    maxHeight: '25vh',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  cardContent: {
    margin: '5px',
    borderRadius: '8px',
    height: '80px',
  },
  searchText: {
    width: '100%',
    height: '42px',
    background: '#FAFAFA',
    border: '1px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '8px',
  },
  journeyThumbnail: {
    height: '60px',
    width: '48px',
    borderRadius: '4px',
  },
  journeyAddIcon: {
    height: '42px',
    width: '42px',
    color: '#622FEE',
    marginLeft: '10px',
    cursor: 'pointer',
  },
  moreIcon: {
    height: '20px',
    cursor: 'pointer',
  },
  menuRoot: {
    width: '100%',
    borderRadius: '8px',
  },
  removeJourney: {
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '138%',
    color: '#667085',
  },
}));

export default function ShowJourneyList({ journeys, ruleId, refreshData }) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchJourneyVal, setSearchJourneyVal] = useState('');
  const [filterJourneyArray, setFilterJourneyArray] = useState([]);
  const [isAddNewJourneyPopupOpen, setIsAddNewJourneyPopupOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [deleteJourneyId, setDeleteJourneyId] = useState(null);

  useEffect(() => {
    setFilterJourneyArray(journeys);
  }, [journeys]);

  const handleSearchJourneys = (e) => {
    const input = e.target.value;
    setSearchJourneyVal(input);
    const filteredIArray = searchArray(journeys, ['journeyTitle'], input);
    setFilterJourneyArray(filteredIArray);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setDeleteJourneyId(null);
  };

  const handleClick = (event, journeyId) => {
    setAnchorEl(event.currentTarget);
    setDeleteJourneyId(journeyId);
  };

  const handleRuleDeleteJourney = async () => {
    await service
      .post(apiEndpoints.RULES_REMOVE_JOURNEY.replace('ID', ruleId), {
        journeyId: deleteJourneyId,
      })
      .then(() => {
        setDeleteJourneyId(null);
        setAnchorEl(null);
        notifySuccess('Journey removed Successfully');
        refreshData();
        dispatch(showProgress(false));
      })
      .catch((error) => {
        setDeleteJourneyId(null);
        setAnchorEl(null);
        dispatch(showProgress(false));
        ErrorToast(error);
      });
  };

  return (
    <div>
      <Grid container direction="row" style={{ marginTop: '20px', marginLeft: '5px' }}>
        <Grid item xs={10}>
          <TextField
            id="searchId"
            name="search"
            required
            autoComplete="off"
            autoSave="off"
            onChange={handleSearchJourneys}
            placeholder="Search journeys"
            value={searchJourneyVal}
            InputProps={{
              disableUnderline: true,
              className: classes.searchText,
            }}
            rows={1}
          />
        </Grid>
        <Grid item xs={2}>
          <AddBoxRounded className={classes.journeyAddIcon} onClick={() => setIsAddNewJourneyPopupOpen(true)} />
        </Grid>
      </Grid>
      {journeys.length ? (
        filterJourneyArray.length ? (
          <Grid container direction="row" className={classes.scrollContent}>
            {filterJourneyArray.map((journey) => (
              <Grid item md={3} key={journey.journeyId}>
                <Card className={classes.cardContent}>
                  <CardContent>
                    <Grid container direction="row">
                      <Grid item xs={3}>
                        <Image alt={journey.name} src={journey.journeyThumbnail} className={classes.journeyThumbnail} />
                      </Grid>
                      <Grid item xs={8}>
                        <Typography noWrap className={classes.primaryText}>
                          {' '}
                          {journey.journeyTitle}
                        </Typography>
                        <Typography noWrap className={classes.secondaryText}>
                          {' '}
                          {journey.journeyPublishDate}
                        </Typography>
                      </Grid>
                      <Grid item xs={1}>
                        <MoreVert className={classes.moreIcon} onClick={(e) => handleClick(e, journey.journeyId)} />
                        <Menu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={handleClose}
                          transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                          }}
                          style={{
                            marginTop: '10px',
                          }}
                        >
                          <MenuItem value="Delete" className={classes.menuRoot} onClick={handleRuleDeleteJourney}>
                            <TrashCanIcon style={{ height: '16px', width: '16px', marginRight: '10px' }} />
                            <span className={classes.removeJourney}>Remove Journey</span>
                          </MenuItem>
                        </Menu>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Grid item xs={12} style={{ textAlign: 'center', marginTop: '10px' }}>
            No journeys Found
          </Grid>
        )
      ) : (
        <ZeroState
          Icon={FileIcon}
          text="No journeys have been added in this rule yet."
          cardWidth="30vw"
          style={{ marginTop: '20px' }}
        />
      )}
      {isAddNewJourneyPopupOpen && (
        <AddNewJourneyToRulePopup
          close={() => setIsAddNewJourneyPopupOpen(false)}
          ruleId={ruleId}
          refreshData={refreshData}
        />
      )}
    </div>
  );
}
